import { useEffect, useState } from 'react'
import { api } from '../../api/client'

type Job = Awaited<ReturnType<typeof api.extractions>>[number]

export default function ExtractionHistory({ companyId }: { companyId: string }) {
  const [jobs, setJobs] = useState<Job[]>([])
  const [selected, setSelected] = useState<Job | null>(null)
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const [notice, setNotice] = useState('')
  const [busy, setBusy] = useState(false)
  const [requestKey, setRequestKey] = useState('')
  useEffect(() => {
    let live = true
    setJobs([]); setSelected(null); setReason(''); setNotice(''); setError('')
    const refresh = () => api.extractions(companyId).then(rows => { if (live) setJobs(rows) }).catch(e => { if (live) setError(e.message) })
    void refresh()
    const timer = window.setInterval(refresh, 4000)
    return () => { live = false; window.clearInterval(timer) }
  }, [companyId])
  async function rerun() {
    if (!selected) return
    setBusy(true); setError('')
    try {
      const result = await api.rerunExtraction(companyId, selected.id, reason, requestKey)
      setNotice(`Extraction is ${result.status.replace(/_/g, ' ')}. Existing answers remain available while it runs.`)
      setSelected(null); setReason('')
      setJobs(await api.extractions(companyId))
    } catch (e) { setError(e instanceof Error ? e.message : 'Could not queue extraction') }
    finally { setBusy(false) }
  }
  return <section className="panel">
    <h2>Extraction history</h2>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {notice && <p className="notice" role="status">{notice}</p>}
    {!jobs.length && <p className="muted">No extraction jobs yet. Incoming replies and transcripts will appear here.</p>}
    {!!jobs.length && <div className="table-wrap"><table className="data">
      <thead><tr><th>Updated</th><th>Status</th><th>Classification</th><th>Action</th></tr></thead>
      <tbody>{jobs.map(job => <tr key={job.id}>
        <td>{new Date(job.updated_at).toLocaleString()}</td>
        <td>{job.status.replace(/_/g, ' ')}{job.error && <p className="muted">{job.error}</p>}</td>
        <td>{job.classification?.replace(/_/g, ' ') || 'Pending'}</td>
        <td><button className="btn small secondary" disabled={busy || ['queued', 'running'].includes(job.status)} onClick={() => { setSelected(job); setReason(''); setRequestKey(crypto.randomUUID()) }}>Rerun extraction</button></td>
      </tr>)}</tbody>
    </table></div>}
    {selected && <form onSubmit={e => { e.preventDefault(); void rerun() }}>
      <p>Reprocess the saved source using the current RFP questions. Prior results and analyst edits are retained; generation costs count toward the lifetime cap.</p>
      <label>Reason<input className="input" required maxLength={2000} value={reason} onChange={e => setReason(e.target.value)} /></label>
      <button className="btn small" disabled={busy || !reason.trim()}>Queue extraction</button>{' '}
      <button type="button" className="btn small secondary" disabled={busy} onClick={() => setSelected(null)}>Cancel</button>
    </form>}
  </section>
}
